const EPSILON = 1e-9;
export function isValueInStepWidth(value, offset, stepWidth) {
    if (Math.abs(stepWidth) < EPSILON) {
        return true;
    }
    const relativeEpsilon = EPSILON * stepWidth;
    const remainder = Math.abs((value - offset) % stepWidth);
    if (remainder < relativeEpsilon || remainder > stepWidth - relativeEpsilon) {
        return true;
    }
    return false;
}
//# sourceMappingURL=isValueInStepWidth.js.map